






























import { Component, Prop, Vue } from "vue-property-decorator";
import { elementTypes } from '@/data/ElementTypes';
import { IElementTypeComplexList } from '@/data/ElementTypeModel';
import _ from "lodash";

@Component
export default class ShopitemlistProperty extends Vue {

    @Prop({ type: String })
    name!: string;

    @Prop({ type: Object })
    value!: any;

    open = false;
    silType = elementTypes.get("shopitemlist") as IElementTypeComplexList;

    get items() {

        const items = Array(36);

        if (this.value) {
            const unorderedItems: string[] = [];
            _.forIn(this.value, (v, k) => {
                if (typeof(v.InventoryLocation) !== "undefined") {
                    items[v.InventoryLocation] = k;
                } else {
                    unorderedItems.push(k);
                }
            });
            unorderedItems.forEach((k) => {
                const firstFreeSlot = _.findIndex(items, (x) => !!x);
                items[firstFreeSlot] = k;
            });
        }

        return items;

    }

    navigate(position: number) {
        this.open = false;
        if (!this.items[position]) {
            // empty slot - create a new item
            // TODO: This might result in duplicate keys
            // if there is already an item with key "position"
            const defaultElement = JSON.parse(JSON.stringify(this.silType.defaultElement));
            _.set(defaultElement, "InventoryLocation", position);
            this.$emit("input", {
                ...this.value,
                [position.toString()]: defaultElement
            });
            this.$emit("change-path", [position.toString()]);
        } else {
            this.$emit("change-path", [this.items[position]]);
        }
    }

}
